// named export (recommended)
export const CAR_RENTAL = {
    // section: ["overviewSection", "roiInvestorBenefits", "operationalBenefits", "operationModels", "communicationChannel"],
    href: "/investments/car-rental",
    overviewSection: {
        sectionId: "rentalInvestment",
        title: "Overview",
        subtitle:
            "The RSL Rental Investment Module offers investors the chance to generate rental income with minimal operational involvement.",
        cards: [
            {
                title: "Investment Options",
                body: "Investor-owned or RSL-purchased vehicles, up to 4 investors per car.",
                arrow: "/img/app/Right-top-arrow.svg",
            },
            {
                title: "Management",
                body: "RSL handles registration, insurance, onboarding, and revenue tracking.",
                arrow: "/img/app/Right-bottom-arrow.svg",
            },
            {
                title: "Profit & ROI",
                body: "Rental income minus 20% management fee, fines, Salik, and expenses.",
                arrow: "/img/app/Right-top-arrow.svg",
            },
            {
                title: "Transparency",
                body: "Full visibility and profitability tracking for investors.",
            },
        ],
        button: { text: "Invest Now", link: "#" },
    },
    roiInvestorBenefits: {
        sectionId: "investorBenefits",
        title: "ROI & Investor Benefits",
        subtitle:
            "Choose which suits you better",
        image: {
            src: "/img/investments/roi.svg",
            alt: " Hands offering coins"
        },
        button: { text: "Invest Now", link: "#" },
    },
    operationalBenefits: {
        sectionId: "operationalBenefits",
        title: "Operational Benefits",
        subtitle:
            "Choose which suits you better",
        ringImage: {
            src: "/img/investments/operationalBenefits.svg",
            alt: "Operational Benefits"
        },
        complianceImage: {
            src: "/img/investments/compliance.svg",
            alt: "Compliance & Car Standards"
        },
        button: { text: "Invest Now", link: "#" },
    },
    operationModels: {
        sectionId: "operationModels",
        title: "Operation Models",
        subtitle:
            "Choose which suits you better",
        tabData: [{
            label: "Investor Owned Vehicle",
            value: "INVESTOR",
            tableData: [
                { item: "Car Insurance", amount: "As per value" },
                { item: "Registration Fee", amount: "2,100" },
                { item: "RMS Tracking", amount: "3,900" },
            ],
            tableFooter: [{
                item: "Total",
                amount: "16,000.00"
            }],
        }, {
            label: "RSL-Purchased Vehicle",
            value: "RSL",
            tableData: [
                { item: "Registration Fee", amount: "2,100" },
                { item: "RMS Tracking", amount: "3,900" },
                { item: "Car Insurance", amount: "As per value" }
            ],
            tableFooter: [{
                item: "Total",
                amount: "16,000.00"
            }],
        }],
        bottomHeader: "Investors provide eligible vehicles to RSL Rental.",
        bottomSubHeader: "RSL Rental registers and onboard the vehicle, listing it across global and UAE platforms.",
        bottomData: [
            {
                top: ["Rentalcars.com", "DiscoverCars.com", "Expedia.com"],
                bottom: ["OneClickDrive.com", "ekar", "Hertz.com"],
            },
            {
                top: ["Kayak.com", "Priceline.com", "Skyscanner.com"],
                bottom: ["Avis.com", "Europcar.com", "Enterprise.com"],
            },
            {
                top: ["Booking.com", "Trip.com", "Opodo"],
                bottom: ["Sixt.com", "Budget.com", "Thrifty.com"],
            },
            {
                top: ["eZhire", "Udrive", "Selfdrive.ae"],
                bottom: ["Payless.com", "Alamo.com", "Nationalcar.com"],
            },
        ],
        button: { text: "Invest Now", link: "#" },
    },
    communicationChannel: {
        sectionId: "communicationChannel",
        title: "Communication Channel",
        subtitle:
            "Choose which suits you better",
        bottomHeader: "RSL ensures smooth communication and transparency for all investors and drivers:",
        cardData: [
            {
                heading: "Call Center (UAE):",
                iconSrc: "/img/investments/phone.svg",
                iconAlt: "Phone",
                url: [
                    {
                        href: "tel:+97143977746",
                        label: "+971 4 397 7746"
                    }
                ]
            },
            {
                heading: "Email (Investors):",
                iconSrc: "/img/investments/email.svg",
                iconAlt: "Email",
                url: [
                    {
                        href: "mailto:investors@royalsmartlifestyle.com",
                        label: "investors@royalsmartlifestyle.com"
                    }
                ]
            },
            {
                heading: "Websites",
                iconSrc: "/img/investments/globe.svg",
                iconAlt: "Globe",
                url: [{
                    href: "https://www.royalsmartlimousine.com",
                    label: "https://www.royalsmartlimousine.com"
                }]
            }
        ],
        image: {
            src: "/images/bannerImage/rsl_super_app.svg",
            alt: "RSL SUPER APP"
        }
    }
};

export const CAR_RENTAL_PAGE = {
    carToInvest: {
        sectionId: "carToInvest",
        title: "Pick Your Car To Rent",
        subtitle:
            "Make journey comfortable with",
        filters: ["All", "Sedan", "SUVs"],
        type: "limousine",
        carData: [
            {
                id: 1,
                segment: "Sedan",
                title: "Mercedes Benz S 500",
                roiPercentage: "Apr.Annual ROI-110%",
                image: "/img/ourfleets/image4.svg",
                stats: [
                    { label: "Down Payment", value: "160,450" },
                    { label: "Income Per Month", value: "30,000" },
                    { label: "Monthly Installment", value: "21,000" },
                ],
                bottomLabel: "You will get this after all expense",
                pricePeriod: [{
                    price: "7,000",
                    period: "/Per Month"
                }, {
                    price: "70,000",
                    period: "/After 5 Years"
                }],
                breakdown: [
                    { label: "Fuel", value: "700 AED" },
                    { label: "Salik", value: "500 AED" },
                    { label: "Maintainance", value: "300 AED" },
                ]
            },
            {
                id: 2,
                segment: "SUVs",
                title: "Mercedes Benz S 500",
                roiPercentage: "Apr.Annual ROI-110%",
                image: "/img/ourfleets/image4.svg",
                stats: [
                    { label: "Down Payment", value: "160,450" },
                    { label: "Income Per Month", value: "30,000" },
                    { label: "Monthly Installment", value: "21,000" },
                ],
                bottomLabel: "You will get this after all expense",
                pricePeriod: [{
                    price: "7,000",
                    period: "/Per Month"
                }, {
                    price: "70,000",
                    period: "/After 5 Years"
                }], breakdown: [
                    { label: "Fuel", value: "700 AED" },
                    { label: "Salik", value: "500 AED" },
                    { label: "Maintainance", value: "300 AED" },
                ]
            },
            {
                id: 3,
                segment: "Sedan",
                title: "Mercedes Benz S 500",
                roiPercentage: "Apr.Annual ROI-110%",
                image: "/img/ourfleets/image4.svg",
                stats: [
                    { label: "Down Payment", value: "160,450" },
                    { label: "Income Per Month", value: "30,000" },
                    { label: "Monthly Installment", value: "21,000" },
                ],
                bottomLabel: "You will get this after all expense",
                pricePeriod: [{
                    price: "7,000",
                    period: "/Per Month"
                }, {
                    price: "70,000",
                    period: "/After 5 Years"
                }], breakdown: [
                    { label: "Fuel", value: "700 AED" },
                    { label: "Salik", value: "500 AED" },
                    { label: "Maintainance", value: "300 AED" },
                ]
            },
            {
                id: 4,
                segment: "SUVs",
                title: "Mercedes Benz S 500",
                roiPercentage: "Apr.Annual ROI-110%",
                image: "/img/ourfleets/image4.svg",
                stats: [
                    { label: "Down Payment", value: "160,450" },
                    { label: "Income Per Month", value: "30,000" },
                    { label: "Monthly Installment", value: "21,000" },
                ],
                bottomLabel: "Profit after expenses",
                pricePeriod: [{
                    price: "7,000",
                    period: "/Per Month"
                }, {
                    price: "70,000",
                    period: "/After 5 Years"
                }], breakdown: [
                    { label: "Fuel", value: "700 AED" },
                    { label: "Salik", value: "500 AED" },
                    { label: "Maintainance", value: "300 AED" },
                ]
            },
            {
                id: 5,
                segment: "Sedan",
                title: "Mercedes Benz S 500",
                roiPercentage: "Apr.Annual ROI-110%",
                image: "/img/ourfleets/image4.svg",
                stats: [
                    { label: "Down Payment", value: "160,450" },
                    { label: "Income Per Month", value: "30,000" },
                    { label: "Monthly Installment", value: "21,000" },
                ],
                bottomLabel: "Profit after expenses",
                pricePeriod: [{
                    price: "7,000",
                    period: "/Per Month"
                }, {
                    price: "70,000",
                    period: "/After 5 Years"
                }], breakdown: [
                    { label: "Fuel", value: "700 AED" },
                    { label: "Salik", value: "500 AED" },
                    { label: "Maintainance", value: "300 AED" },
                ]
            },
            {
                id: 6,
                segment: "SUVs",
                title: "Mercedes Benz S 500",
                roiPercentage: "Apr.Annual ROI-110%",
                image: "/img/ourfleets/image4.svg",
                stats: [
                    { label: "Down Payment", value: "160,450" },
                    { label: "Income Per Month", value: "30,000" },
                    { label: "Monthly Installment", value: "21,000" },
                ],
                bottomLabel: "Profit after expenses",
                pricePeriod: [{
                    price: "7,000",
                    period: "/Per Month"
                }, {
                    price: "70,000",
                    period: "/After 5 Years"
                }], breakdown: [
                    { label: "Fuel", value: "700 AED" },
                    { label: "Salik", value: "500 AED" },
                    { label: "Maintainance", value: "300 AED" },
                ]
            },
        ],
        button: { text: "Investment Breakdown", link: "#" },
    },
    roiInvestorBenefits: {
        sectionId: "overview",
        title: "Investment Guide",
        subtitle:
            "Make journey comfortable with",
        image: {
            src: "/img/investments/limousine/investmentGuide.svg",
            alt: " Hands offering coins"
        },
        bgcolor: "#f8f8f8",
        width: "75%", button: { text: "Invest Now", link: "#" },
    },
    communicationChannel: {
        sectionId: "RSLSuperApp",
        image: {
            src: "/images/bannerImage/rsl_super_app.svg",
            alt: "RSL SUPER APP"
        }
    }
}